module.exports = __webpack_public_path__ + "static/media/The_Mix.602e746d.png";